import { Component, Input } from '@angular/core';
import { BOClassification } from '@boels/models';
import { QaHooksDirective } from '@boels/helpers';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'boels-product-symbols',
  templateUrl: './product-symbols.component.html',
  styleUrls: ['./product-symbols.component.scss'],
  imports: [NgbTooltipModule, QaHooksDirective],
})
export class ProductSymbolsComponent {
  @Input() symbols: BOClassification;
  private imageFolderUrl = '/assets/images/icons/product/symbols/';
  parseSymbolName(featureCode: string, symbolCode: string): string {
    return `${this.imageFolderUrl}${symbolCode.toLowerCase()}.png`;
  }
}
